import React, { useContext } from "react";
import google from "../../../../../images/LandingPageImage/google.png";
import Ornament from "../../../../../images/LandingPageImage/Ornament.svg";
import Navbar from "../../common/Navbar";
import FAQContactSection from "../FAQContactSection";
import CallToAction from "../CallToAction";
import whatsapp_compaign from "../../../../../images/LandingPageImage/whatsapp_compaign.png";
import { Link } from "react-router-dom";
import MyContext from "../../../../../MyContext";
import Footer from "../../common/Footer";

export default function WhatsAppCampaign() {
  const { openFreeTrialModal } = useContext(MyContext);

  return (
    <div>
      <div
        className="hero-bg pt-4 pt-md-5 overflow-hidden font-inter"
        style={{ minHeight: "90vh" }}
      >
        <Navbar />

        <div className="container mt-4 mt-lg-5 mb-5">
          <div className="row align-items-center justify-content-center">
            <div className="col-12 col-lg-6 px-3 px-md-4 order-2 order-lg-1 text-center text-lg-start mt-4 mt-lg-0">
              <h1 className="display-5 display-md-4 fw-semibold font-bricolage mb-3 mb-md-4 lh-sm text-white">
                WhatsApp Campaign <br className="d-none d-md-block" />
                - Grow faster with <br className="d-none d-md-block" />
                <span style={{ color: "yellowgreen" }}> Smart automation</span>
              </h1>

              <p
                className="small text-light opacity-90 mb-4 fw-light mx-auto mx-lg-0"
                style={{ maxWidth: "550px" }}
              >
                Grow faster with smart WhatsApp automation using SendBulkMsg.
                Launch powerful WhatsApp campaigns that automate messages,
                follow-ups, and responses while keeping conversations personal.
                Reach more customers, boost engagement, and drive conversions
                effortlessly as your business scales.
              </p>

              <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-lg-start gap-3 mt-4">
                <Link to="/login" className="text-decoration-none">
                  <button
                    type="button"
                    className="btn btn-outline-google rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 px-4 py-2"
                    style={{ minHeight: "48px" }}
                  >
                    <span
                      className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                      style={{ width: "28px", height: "28px" }}
                    >
                      <img
                        src={google}
                        alt="Google"
                        style={{ width: "16px" }}
                      />
                    </span>
                    <span className="text-nowrap">Start With Google</span>
                  </button>
                </Link>

                <button
                  onClick={openFreeTrialModal}
                  className="btn btn-outline-demo rounded-pill px-4 py-2 fw-semibold d-flex align-items-center justify-content-center"
                  style={{ minHeight: "48px" }}
                >
                  Book a Demo
                </button>
              </div>
            </div>

            <div className="col-12 col-lg-6 mb-4 mb-lg-0 order-2 order-lg-2">
              <div className="position-relative d-flex align-items-center justify-content-center p-2 p-md-3">
                <img
                  src={Ornament}
                  className="img-fluid floating-animation"
                  alt="Background"
                  style={{ opacity: "0.4", filter: "blur(15px)", width: "80%" }}
                />

                <img
                  src={whatsapp_compaign}
                  alt="whatsapp_campaign"
                  className="position-absolute img-fluid main-image-hover"
                  style={{
                    maxWidth: "85%",
                    height: "auto",
                    zIndex: 2,
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <style>{`
         @media (max-width: 991.98px) {
  .display-5 {
    font-size: 2.2rem;
  }
}

.main-image-hover {
  transition: transform 0.5s ease;
}
.main-image-hover:hover {
  transform: scale(1.02);
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
}

.floating-animation {
  animation: float 6s ease-in-out infinite;
}

        `}</style>
      </div>
      <section className="min-vh-100 d-flex who-bg align-items-center font-inter py-5 px-3">
        <div
          className="container mx-auto text-center"
          style={{ maxWidth: "1050px" }}
        >
          <h2 className="fs-2 fw-semibold font-bricolage text-white mb-4">
            What does WhatsApp Campaign do?
          </h2>

          <div className="mb-5 px-md-5 mx-auto" style={{ maxWidth: "900px" }}>
            <p className="fs-6 opacity-90 mb-4 fw-light lh-lg text-yellowgreen">
              A WhatsApp campaign helps businesses reach customers instantly
              through automated, targeted messages on WhatsApp. It allows you to
              promote offers, send updates, follow up with leads, and engage
              users in real time, improving response rates, conversions, and
              overall customer communication.
            </p>
          </div>

          <div className="row g-2 g-lg-3 justify-content-center mt-2">
            <div className="col-12 col-md-6 col-lg-6">
              <div
                className="glass-card h-100 p-3 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h5 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Make Conversations Conversions with WhatsApp Marketing
                </h3>
                <p className="text-white opacity-75 fw-light lh-base">
                  In the case of small businesses, speed, trust and personal
                  touch is most important. The direct access of small business
                  owners on WhatsApp marketing provides precisely direct access
                  to the customers on a platform that they use daily.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-6">
              <div
                className="glass-card h-100 p-3 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h5 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Why is WhatsApp the Best App to use by small businesses?
                </h3>
                <p className="text-white opacity-75 fw-light lh-base">
                  WhatsApp is intimate, real-time, and conversant. WhatsApp
                  customers believe in the messages received on the app more
                  than the conventional marketing platforms. WhatsApp marketing
                  will work as a logical extension of customer service.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="min-vh-100 d-flex who-bg align-items-center font-inter py-5 px-3">
        <div
          className="container mx-auto text-center"
          style={{ maxWidth: "1150px" }}
        >
          <h2 className="fs-2 fw-bold font-bricolage text-white mb-4">
            WhatsApp for E-commerce Growth
          </h2>

          <div className="mb-5 px-md-5 mx-auto" style={{ maxWidth: "900px" }}>
            <p className="fs-6 opacity-90 mb-4 fw-light lh-lg text-yellowgreen">
              Using WhatsApp as a direct sales channel delivers powerful results
              for e-commerce brands. A well-executed e-commerce WhatsApp
              campaign helps online stores increase sales, recover abandoned
              carts, and turn conversations into conversions.
            </p>
          </div>

          <div className="row g-2 gx-lg-3 justify-content-center mt-2">
            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-3 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Smart WhatsApp Campaign Execution
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Launch bulk messaging campaigns, promotional broadcasts, and
                  targeted customer outreach with high delivery success and
                  strong engagement.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Customer-Centric Messaging
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Send personalized messages based on customer behavior and
                  preferences to build trust and drive higher conversion rates
                  through interactions.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Automated Cart Recovery
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Automatically remind customers about abandoned carts, helping
                  e-commerce businesses recover lost sales with minimal manual
                  effort.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="min-vh-100 d-flex who-bg align-items-center font-inter py-5 px-3">
        <div className="container max-w-4xl mx-auto text-center">
          <h2 className="fs-2 fw-bold font-bricolage text-white mb-4">
            WhatsApp as an E-commerce Business Campaign
          </h2>

          <div className="mb-5 px-md-5">
            <p className="fs-6 opacity-90 mb-4 fw-light lh-lg text-yellowgreen">
              Using WhatsApp as a direct sales channel delivers strong results
              for e-commerce brands. A well-planned e-commerce WhatsApp campaign
              helps online stores boost sales, recover abandoned carts, and
              engage customers at the right moment with timely, relevant
              messages.
            </p>
          </div>

          <div className="row g-4 mt-2">
            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  WhatsApp Campaign Management
                </h3>
                <p className="text-white opacity-75 fw-light">
                  Manage automated messaging campaigns, promotional broadcasts,
                  and targeted customer outreach from a single platform,
                  ensuring high delivery rates and better customer engagement
                  throughout the buying journey.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Personalized Messaging
                </h3>
                <p className="text-white opacity-75 fw-light">
                  Send customized messages based on customer behavior and
                  preferences to increase engagement, build trust, and drive
                  higher conversion rates through more meaningful conversations.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Relationships and Long-term Trust
                </h3>
                <p className="text-white opacity-75 fw-light">
                  WhatsApp marketing depends on the trust. SendBulkMsg can
                  assist small enterprises to be credible with proven messaging,
                  opt-in communication, and secure delivery.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Automated Follow-Ups & Cart Recovery
                </h3>
                <p className="text-white opacity-75 fw-light">
                  Automatically remind customers about abandoned carts, pending
                  payments, and incomplete orders, helping e-commerce businesses
                  recover lost sales.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Real-Time Customer Support
                </h3>
                <p className="text-white opacity-75 fw-light">
                  Provide instant responses to customer queries directly on
                  WhatsApp, improving trust, reducing hesitation, and helping
                  shoppers make quicker purchase decisions.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Order Updates & Notifications
                </h3>
                <p className="text-white opacity-75 fw-light">
                  Keep customers informed with automated order confirmations,
                  shipping updates, and delivery alerts, enhancing the
                  post-purchase experience and encouraging repeat sales.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FAQContactSection />
      <CallToAction />
      <Footer />
    </div>
  );
}
